'use strict';

var jsxRuntime = require('react/jsx-runtime');

const PersonOffice = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-person_office--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M52 52V33C52 30.7909 50.2091 29 48 29H12C9.79086 29 8 30.7909 8 33V52",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M48 29H12C9.79086 29 8 30.7909 8 33V45H52V33C52 30.7909 50.2091 29 48 29Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M26 10H10C8.89543 10 8 10.8954 8 12V23C8 24.1046 8.89543 25 10 25H26C27.1046 25 28 24.1046 28 23V12C28 10.8954 27.1046 10 26 10Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M32 27C32 23.6863 34.6863 21 38 21H42C45.3137 21 48 23.6863 48 27V29H32V27Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M40 18C42.2091 18 44 16.2091 44 14C44 11.7909 42.2091 10 40 10C37.7909 10 36 11.7909 36 14C36 16.2091 37.7909 18 40 18Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M21 29V22C21 20.3431 19.6569 19 18 19C16.3431 19 15 20.3431 15 22V29H21Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-person_office",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M52 52V33C52 30.7909 50.2091 29 48 29H12C9.79086 29 8 30.7909 8 33V52",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M48 29H12C9.79086 29 8 30.7909 8 33V45H52V33C52 30.7909 50.2091 29 48 29Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M26 10H10C8.89543 10 8 10.8954 8 12V23C8 24.1046 8.89543 25 10 25H26C27.1046 25 28 24.1046 28 23V12C28 10.8954 27.1046 10 26 10Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M32 27C32 23.6863 34.6863 21 38 21H42C45.3137 21 48 23.6863 48 27V29H32V27Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M40 18C42.2091 18 44 16.2091 44 14C44 11.7909 42.2091 10 40 10C37.7909 10 36 11.7909 36 14C36 16.2091 37.7909 18 40 18Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M21 29V22C21 20.3431 19.6569 19 18 19C16.3431 19 15 20.3431 15 22V29H21Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            })
        ]
    });
};

module.exports = PersonOffice;
